import { Modal, Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import styles from './procedure-image-preview.module.scss'

type ProcedureImagePreviewProps = {
  isOpen: boolean
  onClose: () => void
  imageSrc: string | null
  isLoading?: boolean
  isError?: boolean
}

export const ProcedureImagePreview = ({
  isOpen,
  onClose,
  imageSrc,
  isLoading = false,
  isError = false,
}: ProcedureImagePreviewProps) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  useEffect(() => {
    setIsImageLoaded(false)
  }, [imageSrc, isOpen])

  const showSkeleton = isLoading || (Boolean(imageSrc) && !isImageLoaded)

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width='auto'
      styles={{ body: { padding: 0 } }}
      maskClosable>
      <div className={styles.previewContent}>
        {showSkeleton && (
          <div className={styles.skeletonContainer}>
            <Skeleton.Image active className={styles.skeleton} />
          </div>
        )}
        {imageSrc && (
          <button
            type='button'
            aria-label='Close preview'
            className={styles.imageButton}
            onClick={onClose}
            style={{ display: isImageLoaded ? 'block' : 'none' }}>
            <img
              src={imageSrc}
              alt='Procedure Preview'
              className={styles.previewImage}
              onLoad={() => setIsImageLoaded(true)}
              onError={() => setIsImageLoaded(true)}
            />
          </button>
        )}
        {!isLoading && !imageSrc && (
          <div className={styles.fallbackContainer}>
            <Icon icon='mdi:image-off-outline' width={48} height={48} />
            <span>{isError ? 'Failed to load image' : 'No image available'}</span>
          </div>
        )}
      </div>
    </Modal>
  )
}
